<template>
  <div class="">
    <modal
      v-if="modalCreate.show"
      @close="closeModal"
      :clickOutsideToClose="false"
    >
      <template slot="header">
        <h3 class="modal-title" v-if="modalCreate.action === 'create'">
          {{ $t("user.change_password") }}
        </h3>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeModal"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submit)">
            <div class="md-layout" style="text-align: left">
              <!--  old password   -->
              <div class="md-layout-item md-size-100">
                <label
                  class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label  required-field"
                  style="padding: 0"
                >
                  {{ $t("user.old_password") }}
                </label>
                <ValidationProvider
                  :name="$t('user.old_password')"
                  rules="required"
                  v-slot="{ passed, failed, errors }"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <md-input
                      ref="oldPassword"
                      v-model="params.oldPass"
                      type="password"
                      name="oldPassword"
                    ></md-input>

                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                  <div class="validate-error">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>

              <!--  new password   -->
              <div class="md-layout-item md-size-100">
                <label
                  class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label  required-field"
                  style="padding: 0"
                >
                  {{ $t("user.new_password") }}
                </label>
                <ValidationProvider
                  vid="newPassword"
                  :name="$t('user.new_password')"
                  rules="required|strongPassword"
                  v-slot="{ passed, failed, errors }"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <md-input
                      v-model="params.password"
                      type="password"
                      name="newPassword"
                    ></md-input>

                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                  <div class="validate-error">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>

              <!--  new password confirm   -->
              <div class="md-layout-item md-size-100">
                <label
                  class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label  required-field"
                  style="padding: 0"
                >
                  {{ $t("user.new_password_confirm") }}
                </label>
                <ValidationProvider
                  :name="$t('user.new_password_confirm')"
                  rules="required|confirmed:newPassword"
                  v-slot="{ passed, failed, errors }"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <md-input
                      v-model="params.passwordConfirm"
                      type="password"
                      name="passwordConfirm"
                    ></md-input>

                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                  <div class="validate-error">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
            <md-card-actions class="text-center">
              <md-button
                type="submit"
                class="md-success"
                style="margin-right: 10px;"
                >{{ $t("common.save") }}
              </md-button>
              <md-button class="md-danger" @click="closeModal"
                >{{ $t("common.close") }}
              </md-button>
            </md-card-actions>
          </form>
        </ValidationObserver>
      </template>
    </modal>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
import { Modal } from "@/components";
import sanitizer from "sanitizer";
import { AuthService } from "../../services/auth.service";

export default {
  name: "ResetPassModal",
  data() {
    return {
      params: {
        oldPass: null,
        password: null,
        passwordConfirm: null
      }
    };
  },
  components: {
    Modal,
    SlideYDownTransition
  },
  methods: {
    submit() {
      this.resetPassword();
    },
    async resetPassword() {
      const response = await AuthService.resetPassword({
        old_password: this.params.oldPass,
        password: this.params.password,
        password_confirm: this.params.passwordConfirm
      });
      this.closeModal();
      if (!response) {
        return;
      }
      this.$notify({
        title: this.$t("user.updated"),
        text: this.$t("user.reset_pass_text", {
          name: sanitizer.escape(response.name)
        }),
        type: "success"
      });
    },
    closeModal() {
      this.resetParams();
      this.$emit("closeModal");
    },
    resetParams() {
      this.params.oldPass = null;
      this.params.password = null;
      this.params.passwordConfirm = null;
    }
  },
  props: ["modalCreate", "item"],
  mounted() {},
  watch: {}
};
</script>

<style scoped>
.label-design {
  font-size: 19px;
  font-weight: 700;
  margin-top: 28px;
  margin-bottom: 28px;
}

.md-menu-content-bottom-start {
  z-index: 90000000 !important;
}
</style>
